<template>
  <v-layout align-center justify-center column class="date-range-container">
    {{calculatedText}}
  </v-layout>
</template>

<script>
  import moment from "moment";
  import BusinessDateFormats from "@/modules/common/filters/BusinessDateFormats/BusinessDateFormats";

  export default {
    props: {
      startDate: {
        type: [Date, String],
        required: true,
      },
      endDate: {
        type: [Date, String],
        default: '',
      },
      duration: {
        type: Number,
        default: 0,
      },
      isFullMonthName: {
        type: Boolean,
        default: false,
      }
    },
    computed: {
      parsedEndDate() {
        let parsedEndDate;
        if (this.duration) {
          const parsedStartDate = moment(this.startDate)
          parsedEndDate = parsedStartDate.add(this.duration, 'days')
        } else {
          parsedEndDate = moment(this.endDate)
        }
        return parsedEndDate;
      },
      calculatedText() {
        return BusinessDateFormats.date_range(this.startDate.toISOString(), this.parsedEndDate.toISOString(), this.isFullMonthName)
      },
    }
  }
</script>

<style lang="scss" scoped>
.date-range-container {
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
}
</style>
